export const START_LOADING = 'app/services/Vehicles/START_LOADING';
export const START_LOADING_VEHICLES = 'app/services/Vehicles/START_LOADING_VEHICLES';
export const START_LOADING_LIGHT_VEHICLES = 'app/services/Vehicles/START_LOADING_LIGHT_VEHICLES';
export const CLEAR_VEHICLE_ERRORS = 'app/services/Vehicles/CLEAR_VEHICLE_ERRORS';
export const START_REFRESH_FUEL_LOADING = 'app/services/Vehicles/START_REFRESH_FUEL_LOADING';
export const START_REFRESH_BATTERY_LOADING = 'app/services/Vehicles/START_REFRESH_BATTERY_LOADING';
export const START_REFRESH_ODOMETER_LOADING = 'app/services/Vehicles/START_REFRESH_ODOMETER_LOADING';
export const SELECT_VIEW = 'app/services/Vehicles/SELECT_VIEW';
export const ADD_FILTER = 'app/services/Vehicles/ADD_FILTER';
export const REMOVE_FILTER = 'app/services/Vehicles/REMOVE_FILTER';
export const SET_FILTERS = 'app/services/Vehicles/SET_FILTERS';
export const CLEAR_FILTERS = 'app/services/Vehicles/CLEAR_FILTERS';
export const CLEAR_VEHICLE = 'app/services/Vehicles/CLEAR_VEHICLE';
export const SET_COLUMNS = 'app/services/Vehicles/SET_COLUMNS';
export const SET_SORT_BY = 'app/services/Vehicles/SET_SORT_BY';
export const SET_SEARCH_QUERY = 'app/services/Vehicles/SET_SEARCH_QUERY';
export const RESET_VEHICLES_DATA = 'app/services/Vehicles/RESET_VEHICLES_DATA';
export const SET_VEHICLE = 'app/services/Vehicles/SET_VEHICLE_DATA';

export const SET_VEHICLES_OFFSET = 'app/services/Vehicles/SET_VEHICLES_OFFSET';
export const GET_VEHICLES_SUCCESS = 'app/services/Vehicles/GET_VEHICLES_SUCCESS';
export const GET_VEHICLES_FAIL = 'app/services/Vehicles/GET_VEHICLES_FAIL';
export const GET_VEHICLES_LIGHT_SUCCESS = 'app/services/Vehicles/GET_VEHICLES_LIGHT_SUCCESS';
export const GET_VEHICLES_LIGHT_FAIL = 'app/services/Vehicles/GET_VEHICLES_LIGHT_FAIL';
export const START_LOADING_DASHBOARD_VEHICLES = 'app/services/Vehicles/START_LOADING_DASHBOARD_VEHICLES';
export const GET_DASHBOARD_VEHICLES_SUCCESS = 'app/services/Vehicles/GET_DASHBOARD_VEHICLES_SUCCESS';
export const GET_DASHBOARD_VEHICLES_FAIL = 'app/services/Vehicles/GET_DASHBOARD_VEHICLES_FAIL';

export const GET_DEPARTMENTS_SUCCESS = 'app/services/Vehicles/GET_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENTS_FAIL = 'app/services/Vehicles/GET_DEPARTMENTS_FAIL';
export const GET_STATUSES_SUCCESS = 'app/services/Vehicles/GET_STATUSES_SUCCESS';
export const GET_STATUSES_FAIL = 'app/services/Vehicles/GET_STATUSES_FAIL';

export const GET_VEHICLE_SUCCESS = 'app/services/Vehicle/GET_VEHICLE_SUCCESS';
export const GET_VEHICLE_FAIL = 'app/services/Vehicle/GET_VEHICLE_FAIL';
export const UPDATE_VEHICLE_SUCCESS = 'app/services/Vehicle/UPDATE_VEHICLE_SUCCESS';
export const UPDATE_VEHICLE_DEPARTMENT_SUCCESS = 'app/services/Vehicle/UPDATE_VEHICLE_DEPARTMENT_SUCCESS';
export const UPDATE_VEHICLE_FAIL = 'app/services/Vehicle/UPDATE_VEHICLE_FAIL';
export const GET_MODELS_SUCCESS = 'app/services/Vehicle/GET_MODELS_SUCCESS';
export const GET_MODELS_FAIL = 'app/services/Vehicle/GET_MODELS_FAIL';
export const GET_HISTORY_SUCCESS = 'app/services/Vehicle/GET_HISTORY_SUCCESS';
export const GET_HISTORY_FAIL = 'app/services/Vehicle/GET_HISTORY_FAIL';

export const SET_DAMAGES_SUCCESS = 'app/services/Vehicle/SET_DAMAGES_SUCCESS';
export const SET_DAMAGES_FAIL = 'app/services/Vehicle/SET_DAMAGES_FAIL';
export const ADD_DAMAGE_SUCCESS = 'app/services/Vehicle/ADD_DAMAGE_SUCCESS';
export const ADD_DAMAGE_FAIL = 'app/services/Vehicle/ADD_DAMAGE_FAIL';
export const UPDATE_DAMAGE_SUCCESS = 'app/services/Vehicle/UPDATE_DAMAGE_SUCCESS';
export const UPDATE_DAMAGE_FAIL = 'app/services/Vehicle/ADD_DAMAGE_FAIL';
export const REMOVE_DAMAGE_SUCCESS = 'app/services/Vehicle/REMOVE_DAMAGE_SUCCESS';
export const REMOVE_DAMAGE_FAIL = 'app/services/Vehicle/REMOVE_DAMAGE_FAIL';

export const ADD_DAMAGE_PICTURE_SUCCESS = 'app/services/Vehicle/ADD_DAMAGE_PICTURE_SUCCESS';
export const ADD_DAMAGE_PICTURE_FAIL = 'app/services/Vehicle/ADD_DAMAGE_PICTURE_FAIL';
export const REMOVE_DAMAGE_PICTURE_SUCCESS = 'app/services/Vehicle/REMOVE_DAMAGE_PICTURE_SUCCESS';
export const REMOVE_DAMAGE_PICTURE_FAIL = 'app/services/Vehicle/REMOVE_DAMAGE_PICTURE_FAIL';

export const CREATE_AGREEMENT_SUCCESS = 'app/services/Vehicle/CREATE_AGREEMENT_SUCCESS';
export const CREATE_AGREEMENT_FAIL = 'app/services/Vehicle/GET_AGREEMENTS_FAIL';
export const ADD_VEHICLE_NOTE_SUCCESS = 'app/services/Vehicle/ADD_NOTE_SUCCESS';
export const ADD_VEHICLE_NOTE_FAIL = 'app/services/Vehicle/ADD_NOTE_FAIL';
export const UPDATE_VEHICLE_NOTE_SUCCESS = 'app/services/Vehicle/UPDATE_VEHICLE_NOTE_SUCCESS';
export const UPDATE_VEHICLE_NOTE_FAIL = 'app/services/Vehicle/UPDATE_VEHICLE_NOTE_FAIL';

export const CHANGE_PER_PAGE_VALUE = 'app/services/Vehicles/CHANGE_PER_PAGE_VALUE';

export const ADD_VEHICLE_SUCCESS = 'app/services/Vehicles/ADD_VEHICLE_SUCCESS';
export const ADD_VEHICLE_FAIL = 'app/services/Vehicles/ADD_VEHICLE_FAIL';

export const CHANGED_OWNER_SUCCESS = 'app/services/Vehicles/CHANGED_OWNER_SUCCESS';
export const CHANGED_OWNER_FAIL = 'app/services/Vehicles/CHANGED_OWNER_FAIL';
export const REFRESH_FUEL_SUCCESS = 'app/services/Vehicles/REFRESH_FUEL_SUCCESS';
export const REFRESH_BATTERY_SUCCESS = 'app/services/Vehicles/REFRESH_BATTERY_SUCCESS';
export const REFRESH_ODOMETER_SUCCESS = 'app/services/Vehicles/REFRESH_ODOMETER_SUCCESS';
export const REFRESH_CONNECTED_DATA_SUCCESS = 'app/services/Vehicles/REFRESH_CONNECTED_DATA_SUCCESS';
export const REFRESH_CONNECTED_DATA_FAIL = 'app/services/Vehicles/REFRESH_CONNECTED_DATA_FAIL';
export const SET_ODOMETER_OFFSET_SUCCESS = 'app/services/Vehicle/SET_ODOMETER_OFFSET_SUCCESS';
export const SET_ODOMETER_OFFSET_FAIL = 'app/services/Vehicle/SET_ODOMETER_OFFSET_FAIL';

export const SET_ACTIVE_TAB = 'app/services/Vehicle/SET_ACTIVE_TAB';

export const SET_CALENDAR_START = 'app/services/Vehicle/SET_CALENDAR_START';

export const startLoading = () => ({
  type: START_LOADING,
});

export const startLoadingVehicles = (requestId) => ({
  type: START_LOADING_VEHICLES,
  payload: { requestId },
});

export const startLoadingLightVehicles = () => ({
  type: START_LOADING_LIGHT_VEHICLES,
});

export const startRefreshFuelLoading = () => ({
  type: START_REFRESH_FUEL_LOADING,
});

export const startRefreshBatteryLoading = () => ({
  type: START_REFRESH_BATTERY_LOADING,
});

export const startRefreshOdometerLoading = () => ({
  type: START_REFRESH_ODOMETER_LOADING,
});

export const receivedClearVehicle = () => ({
  type: CLEAR_VEHICLE,
});

export const receivedClearVehicleErrors = () => ({
  type: CLEAR_VEHICLE_ERRORS,
});

export const receivedSelectedView = (view) => ({
  type: SELECT_VIEW,
  payload: { view },
});

export const receivedNewFilter = (filter) => ({
  type: ADD_FILTER,
  payload: { filter },
});

export const receivedRemoveFilter = (index) => ({
  type: REMOVE_FILTER,
  payload: { index },
});

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: { filters },
});

export const receivedClearFilters = () => ({
  type: CLEAR_FILTERS,
});

export const receivedSetColumns = (columns) => ({
  type: SET_COLUMNS,
  payload: { columns },
});

export const receivedResetVehicles = () => ({
  type: RESET_VEHICLES_DATA,
});

export const receivedSetVehicle = (vehicle) => ({
  type: SET_VEHICLE,
  payload: {
    vehicle,
  },
});

export const receivedVehiclesOffset = (offset) => ({
  type: SET_VEHICLES_OFFSET,
  payload: { offset },
});

export const receivedSetActiveTab = (tab) => ({
  type: SET_ACTIVE_TAB,
  payload: { tab },
});

export const receivedSetCalendarStart = (start) => ({
  type: SET_CALENDAR_START,
  payload: { start },
});

export const receivedSetSearchQuery = (searchQuery) => ({
  type: SET_SEARCH_QUERY,
  payload: { searchQuery },
});

export const receivedVehiclesSuccess = (data, offset, requestId) => ({
  type: GET_VEHICLES_SUCCESS,
  payload: {
    data,
    offset,
    requestId,
  },
});

export const receivedVehiclesFail = (errors, requestId) => ({
  type: GET_VEHICLES_FAIL,
  payload: { errors, requestId },
});

export const receivedVehiclesLightSuccess = (data) => ({
  type: GET_VEHICLES_LIGHT_SUCCESS,
  payload: {
    data,
  },
});

export const receivedVehiclesLightFail = (errors) => ({
  type: GET_VEHICLES_LIGHT_FAIL,
  payload: { errors },
});

export const startLoadingDashboardVehicles = () => ({
  type: START_LOADING_DASHBOARD_VEHICLES,
});

export const receivedDashboardVehiclesSuccess = (data) => ({
  type: GET_DASHBOARD_VEHICLES_SUCCESS,
  payload: { data },
});

export const receivedDashboardVehiclesFail = (errors) => ({
  type: GET_DASHBOARD_VEHICLES_FAIL,
  payload: { errors },
});

export const receivedPerPageValue = (perPage) => ({
  type: CHANGE_PER_PAGE_VALUE,
  payload: { perPage },
});

export const receivedAddVehicleSuccess = (data) => ({
  type: ADD_VEHICLE_SUCCESS,
  payload: { data },
});

export const receivedAddVehicleFail = (errors) => ({
  type: ADD_VEHICLE_FAIL,
  payload: { errors },
});

export const receivedChangedVehiclesOwnerSuccess = (vehicles, owner) => ({
  type: CHANGED_OWNER_SUCCESS,
  payload: {
    vehicles,
    owner,
  },
});

export const receivedChangedVehiclesOwnerFail = (errors) => ({
  type: CHANGED_OWNER_SUCCESS,
  payload: { errors },
});

export const receivedDepartmentsSuccess = (data) => ({
  type: GET_DEPARTMENTS_SUCCESS,
  payload: {
    data,
  },
});

export const receivedDepartmentsFail = (errors) => ({
  type: GET_DEPARTMENTS_FAIL,
  payload: { errors },
});

export const receivedStatusesSuccess = (data) => ({
  type: GET_STATUSES_SUCCESS,
  payload: {
    data,
  },
});

export const receivedStatusesFail = (errors) => ({
  type: GET_STATUSES_FAIL,
  payload: { errors },
});

export const receivedVehicleSuccess = (data) => ({
  type: GET_VEHICLE_SUCCESS,
  payload: {
    data,
  },
});

export const receivedVehicleFail = (errors) => ({
  type: GET_VEHICLE_FAIL,
  payload: { errors },
});

export const receivedSetDamagesSuccess = (data) => ({
  type: SET_DAMAGES_SUCCESS,
  payload: {
    data,
  },
});

export const receivedSetDamagesFail = (errors) => ({
  type: SET_DAMAGES_FAIL,
  payload: { errors },
});

export const receivedAddDamageSuccess = (damage) => ({
  type: ADD_DAMAGE_SUCCESS,
  payload: {
    damage,
  },
});

export const receivedAddDamageFail = (errors) => ({
  type: ADD_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedUpdateDamageSuccess = (damage) => ({
  type: UPDATE_DAMAGE_SUCCESS,
  payload: {
    damage,
  },
});

export const receivedUpdateDamageFail = (errors) => ({
  type: UPDATE_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedRemoveDamageSuccess = (damageId) => ({
  type: REMOVE_DAMAGE_SUCCESS,
  payload: {
    damageId,
  },
});

export const receivedRemoveDamageFail = (errors) => ({
  type: REMOVE_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedAddDamagePictureSuccess = (damageId, pictures) => ({
  type: ADD_DAMAGE_PICTURE_SUCCESS,
  payload: {
    damageId,
    pictures,
  },
});

export const receivedAddDamagePictureFail = (errors) => ({
  type: ADD_DAMAGE_PICTURE_FAIL,
  payload: { errors },
});

export const receivedRemoveDamagePictureSuccess = (damageId, pictureId) => ({
  type: REMOVE_DAMAGE_PICTURE_SUCCESS,
  payload: {
    damageId,
    pictureId,
  },
});

export const receivedRemoveDamagePictureFail = (errors) => ({
  type: REMOVE_DAMAGE_PICTURE_FAIL,
  payload: { errors },
});

export const updateVehicleInfoSuccess = (newVehicleInfo) => ({
  type: UPDATE_VEHICLE_SUCCESS,
  payload: {
    newVehicleInfo,
  },
});

export const updateVehicleInfoFail = (errors) => ({
  type: UPDATE_VEHICLE_FAIL,
  payload: {
    errors,
  },
});

export const receivedModelsSuccess = (data) => ({
  type: GET_MODELS_SUCCESS,
  payload: {
    data,
  },
});

export const receivedModelsFail = (errors) => ({
  type: GET_MODELS_FAIL,
  payload: {
    errors,
  },
});

export const receivedAddVehicleNoteSuccess = (note) => ({
  type: ADD_VEHICLE_NOTE_SUCCESS,
  payload: { note },
});

export const receivedAddVehicleNoteFail = (errors) => ({
  type: ADD_VEHICLE_NOTE_FAIL,
  payload: { errors },
});

export const receivedUpdateVehicleNoteSuccess = (note) => ({
  type: UPDATE_VEHICLE_NOTE_SUCCESS,
  payload: { note },
});

export const receivedUpdateVehicleNoteFail = (errors) => ({
  type: UPDATE_VEHICLE_NOTE_FAIL,
  payload: { errors },
});

export const receivedHistorySuccess = (data) => ({
  type: GET_HISTORY_SUCCESS,
  payload: {
    data,
  },
});

export const receivedHistoryFail = (errors) => ({
  type: GET_HISTORY_FAIL,
  payload: {
    errors,
  },
});

export const receivedCreateAgreementSuccess = (agreement) => ({
  type: CREATE_AGREEMENT_SUCCESS,
  payload: { agreement },
});

export const receivedCreateAgreementFail = (errors) => ({
  type: CREATE_AGREEMENT_FAIL,
  payload: { errors },
});

export const receivedRefreshConnectedVehicleDataSuccess = (vehicle) => ({
  type: REFRESH_CONNECTED_DATA_SUCCESS,
  payload: {
    vehicle,
  },
});

export const receivedRefreshConnectedVehicleDataFail = (errors) => ({
  type: REFRESH_CONNECTED_DATA_FAIL,
  payload: { errors },
});

export const receivedRefreshFuelSuccess = (vehicle) => ({
  type: REFRESH_FUEL_SUCCESS,
  payload: {
    connectedFuelLevel: vehicle.connectedFuelLevel,
    fuelLevel: vehicle.fuelLevel,
    fuelLevelDate: vehicle.fuelLevelDate,
    fuelLevelStale: vehicle.fuelLevelStale,
    isConnected: vehicle.isConnected,
  },
});

export const receivedRefreshBatterySuccess = (vehicle) => ({
  type: REFRESH_BATTERY_SUCCESS,
  payload: {
    connectedBatteryLevel: vehicle.connectedBatteryLevel,
    batteryLevel: vehicle.batteryLevel,
    batteryLevelDate: vehicle.batteryLevelDate,
    isConnected: vehicle.isConnected,
  },
});

export const receivedUpdateVehicleDepartmentSuccess = () => ({
  type: UPDATE_VEHICLE_DEPARTMENT_SUCCESS,
});

export const receivedRefreshOdometerSuccess = (vehicle) => ({
  type: REFRESH_ODOMETER_SUCCESS,
  payload: {
    odometer: vehicle.odometer,
    connectedOdometer: vehicle.connectedOdometer,
    mileageCalculated: vehicle.mileageCalculated,
    mileageCalculatedDate: vehicle.mileageCalculatedDate,
    odometerInitial: vehicle.odometerInitial,
    odometerInitialDate: vehicle.odometerInitialDate,
    odometerStale: vehicle.odometerStale,
    isConnected: vehicle.isConnected,
  },
});

export const receivedAdjustOdometerOffsetSuccess = () => ({
  type: SET_ODOMETER_OFFSET_SUCCESS,
});

export const receivedAdjustOdometerOffsetFail = (errors) => ({
  type: SET_ODOMETER_OFFSET_FAIL,
  payload: {
    errors,
  },
});
